'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/ui-kit/utils';
import { BUTTON_S_CLASS, LABEL_CLASS } from '../constants';
import type { PriceAlertExpires } from '../types';

interface ExpiresFieldProps {
  value: PriceAlertExpires;
  onChange: (value: PriceAlertExpires) => void;
}

const OPTIONS: PriceAlertExpires[] = ['DURATION_7D', 'DURATION_24H', 'UNTIL_END'];

export function ExpiresField({ value, onChange }: ExpiresFieldProps) {
  const tf = useTranslations('priceAlerts.form');

  const labelFor = (opt: PriceAlertExpires) =>
    opt === 'DURATION_7D'
      ? tf('expiresOptions.7d')
      : opt === 'DURATION_24H'
        ? tf('expiresOptions.24h')
        : tf('expiresOptions.untilEnd');

  return (
    <div className="flex flex-col gap-2">
      <span className={LABEL_CLASS}>{tf('expires')}</span>
      <RadioGroupPrimitive.Root
        value={value}
        onValueChange={(v) => onChange(v as PriceAlertExpires)}
        className="flex h-10 items-center gap-1 rounded-[10px] bg-v2-btn-secondary p-1"
        aria-label={tf('expires')}
      >
        {OPTIONS.map((opt) => {
          const active = value === opt;
          return (
            <RadioGroupPrimitive.Item
              key={opt}
              value={opt}
              className={cn(
                'flex flex-1 cursor-pointer items-center justify-center self-stretch rounded-[8px] px-2 outline-none transition-colors focus-visible:ring-1 focus-visible:ring-v2-border',
                BUTTON_S_CLASS,
                active
                  ? 'bg-v2-surface-primary text-v2-text-primary shadow-sm dark:bg-v2-surface-tertiary dark:shadow-none'
                  : 'bg-transparent text-v2-text-secondary hover:text-v2-text-primary',
              )}
            >
              {labelFor(opt)}
            </RadioGroupPrimitive.Item>
          );
        })}
      </RadioGroupPrimitive.Root>
    </div>
  );
}
